export const GET_AUTHORIZED_USER_REQUEST = 'GET_AUTHORIZED_USER_REQUEST';
export const GET_AUTHORIZED_USER_SUCCESS = 'GET_AUTHORIZED_USER_SUCCESS';
export const GET_AUTHORIZED_USER_FAILED = 'GET_AUTHORIZED_USER_FAILED';

export const UPDATE_AUTHORIZED_USER_REQUEST = 'UPDATE_AUTHORIZED_USER_REQUEST';
export const UPDATE_AUTHORIZED_USER_SUCCESS = 'UPDATE_AUTHORIZED_USER_SUCCESS';
export const UPDATE_AUTHORIZED_USER_FAILED = 'UPDATE_AUTHORIZED_USER_FAILED';

export const DELETE_AUTHORIZED_USER_REQUEST = 'DELETE_AUTHORIZED_USER_REQUEST';
export const DELETE_AUTHORIZED_USER_SUCCESS = 'DELETE_AUTHORIZED_USER_SUCCESS';
export const DELETE_AUTHORIZED_USER_FAILED = 'DELETE_AUTHORIZED_USER_FAILED';

export const SET_AUTHORIZED_USER_PET = 'SET_ACTIVE_AUTHORIZED_USER';
